import {
  getAnalytics,
  isSupported,
  logEvent,
  setUserId,
} from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

declare const __FIREBASE_API_KEY__: string
declare const __FIREBASE_PROJECT_ID__: string
declare const __FIREBASE_APP_ID__: string
declare const __FIREBASE_MEASUREMENT_ID__: string

const firebaseConfig = {
  apiKey: __FIREBASE_API_KEY__,
  projectId: __FIREBASE_PROJECT_ID__,
  appId: __FIREBASE_APP_ID__,
  measurementId: __FIREBASE_MEASUREMENT_ID__,
}

const isConfigured =
  !!firebaseConfig.apiKey &&
  !!firebaseConfig.projectId &&
  !!firebaseConfig.appId

const app = isConfigured ? initializeApp(firebaseConfig) : undefined

let analyticsInstance: ReturnType<typeof getAnalytics> | undefined

export async function initFirebaseAnalytics() {
  if (!app) return
  const supported = await isSupported()
  if (supported) {
    analyticsInstance = getAnalytics(app)
  }
}

export function sendAnalyticsEvent(
  eventName: string,
  params?: Record<string, unknown>
) {
  if (!analyticsInstance) return
  try {
    logEvent(analyticsInstance, eventName, params)
  } catch {
    // silently fail
  }
}

export function sendAnalyticsUserId(id: string) {
  if (!analyticsInstance) return
  try {
    setUserId(analyticsInstance, id)
  } catch {
    // silently fail
  }
}
